import { Component, Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import {
  type WistiaFormReference,
  wistiaEventMetaFields,
  wistiaFormLayoutFields,
  wistiaFormReferenceFields,
  wistiaRedirectFields,
} from 'components/WistiaForm/config';

const wistiaSplitFields = [
  ...moleculeHeadingFields,
  ...wistiaEventMetaFields,
  {
    name: 'reverse',
    type: 'boolean',
    defaultValue: false,
    helperText: 'When on, the form shows on the left and the heading on the right (desktop). Stacked on mobile.',
  },
  ...wistiaFormReferenceFields(),
  ...wistiaFormLayoutFields,
  ...wistiaRedirectFields,
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const wistiaSplitConfig = {
  name: 'WistiaSplit',
  inputs: wistiaSplitFields,
} satisfies Component;

export type WistiaSplitConfigProps = Omit<GenerateBuilder<typeof wistiaSplitFields>, 'form'> & {
  form?: WistiaFormReference;
};

export default wistiaSplitConfig;
